import { css } from 'styled-components';
import token from 'styled-token';
import { alphaMixin } from '../alphaMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class PropertyCardBadgeMixin */
/** @method */
export var PropertyCardBadgeMixin = function PropertyCardBadgeMixin(props) {
  var appearance = props.appearance;
  return token({
    backgroundColor: "PropertyCard.badge.backgroundColor." + appearance,
    borderRadius: 'PropertyCard.badge.borderRadius',
    fontColor: 'PropertyCard.badge.fontColor',
    fontType: 'PropertyCard.badge.fontType',
    horizontalPadding: "PropertyCard.badge.horizontalPadding",
    opacity: "PropertyCard.badge.opacity." + appearance,
    verticalPadding: "PropertyCard.badge.verticalPadding"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      opacity = _ref.opacity,
      verticalPadding = _ref.verticalPadding;
    return css(["background-color:", ";border-radius:", ";color:", ";display:inline-block;padding:", "px ", "px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", " ", ""], alphaMixin(backgroundColor, opacity)(props), borderRadius, fontColor, verticalPadding, horizontalPadding, typographyMixin(Object.assign({
      fontType: fontType,
      fontColor: fontColor
    }, props)), spacingMixin(props));
  })(props);
};